/**
 * Get the current hour in a specific timezone using Intl API
 * Falls back to local hour if timezone is invalid
 *
 * @param date - Date to extract hour from (defaults to now)
 * @param timeZone - IANA timezone string (e.g., 'America/New_York')
 * @returns Hour in 24-hour format (0-23)
 */
export function getHourInTimeZone(
  date: Date = new Date(),
  timeZone?: string
): number {
  try {
    const formatter = new Intl.DateTimeFormat('en-US', {
      hour: 'numeric',
      hour12: false,
      timeZone,
    });
    const parts = formatter.formatToParts(date);
    const hourPart = parts.find(p => p.type === 'hour');
    return hourPart ? Number(hourPart.value) : date.getHours();
  } catch {
    // Invalid timezone - fall back to local time
    return date.getHours();
  }
}

/**
 * Get the browser's current timezone
 * @returns IANA timezone string (e.g., 'America/Toronto')
 */
export function getBrowserTimeZone(): string {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}
